import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ExternalHTMLProvider {

  constructor(public http: HttpClient) {}

  get(file: string): Observable<string> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'text/html'
    });
    return this.http.get(file, {
      headers: headersConfig,
      responseType: 'text'
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/external-html/external-html.ts